import React from 'react';
import './Header.css'
import admin from '../../../images/admin.jpeg'
import Typewriter from 'typewriter-effect'
import Fade from 'react-reveal/Fade';
import ParticleBackground from '../../Particle/ParticleBackground';
const Header = () => {
    return (
        <ParticleBackground>
            <section className="header">
            <Fade left>
            <div className='intro'>
                <h1 className="intro-line">
                    <span>H</span>
                    <span>i</span>
                    <span>,</span>
                </h1>
                <h1 className="intro-line">
                    <span>I</span>
                    <span>'</span>
                    <span>m</span>
                    <b> </b>
                    <span style={{ color: "#64ffda", fontFamily: "Righteous" }}>N</span>
                    <span>a</span>
                    <span>b</span>
                    <span>i</span>
                    <span>l</span>
                </h1>
                <h1 className="intro-line">
                    <span>B</span>
                    <span>u</span>
                    <span>i</span>
                    <span>l</span>
                    <span>d</span>
                    <b> </b>
                    <span>t</span>
                    <span>h</span>
                    <span>i</span>
                    <span>n</span>
                    <span>g</span>
                    <span>s</span>
                    <b> </b>
                    <span>f</span>
                    <span>o</span>
                    <span>r</span>
                    <b> </b>
                    <span>t</span>
                    <span>h</span>
                    <span>e</span>
                    <b> </b>
                    <span>W</span>
                    <span>e</span>
                    <span>b</span>
                </h1>
                <div>
                    <h2 className="typewriter">
                        <Typewriter
                            options={{
                                strings: ['Front End Developer', 'Javascript Developer ', 'React Developer'],
                                autoStart: true,
                                loop: true,
                            }}
                        />

                    </h2>
                </div>
                <br />
                <br/>

                <a className="resume-link" href="https://drive.google.com/uc?export=download&id=19f_GCqmVr2QJ09h0FT7a5S2oew6u1_5D" target="_blank" rel="noreferrer">
                    <button className="main-btn">
                    <i class="fa fa-download" style={{color:'#64ffda'}} aria-hidden="true"></i>  Resume</button>
                </a>
            </div>
           </Fade>
            <Fade top>
            <div className="header-img">
                {/* <img src={admin} alt="" /> */}
            </div>
            </Fade>


        </section>
        </ParticleBackground>
    );
};

export default Header;